import { NgModule } from '@angular/core';
import { EolPipe } from './eol.pipe';
import { SafeUrlPipe } from './safeurl.pipe';
import { SafeHtmlPipe } from './safehtml.pipe';
import { FilterValuesPipe } from './filtervalues.pipe';

@NgModule({
    declarations: [
        EolPipe,
        FilterValuesPipe,
        SafeUrlPipe,
        SafeHtmlPipe,
    ],
    exports: [
        EolPipe,
        FilterValuesPipe,
        SafeUrlPipe,
        SafeHtmlPipe,
    ],
    imports: [],
    providers: [],
})
export class PipesModule { }
